import { adminRouteMiddleware } from '@/middlewares/admin-middleware';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/admin')({
  component: Outlet,
  server: {
    middleware: [adminRouteMiddleware],
  },
});
